import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import NotificationPopup from './NotificationPopup';

const NotificationHandler = () => {
    const { notification, setNotification } = useContext(AuthContext);

    const handleCloseNotification = () => {
        setNotification(null);
    };

    return (
        <NotificationPopup 
            notification={notification} 
            onClose={handleCloseNotification} 
        />
    );
};

export default NotificationHandler; 